import { useDispatch, useSelector } from "react-redux";
import Timeline from "./Timeline";
import { forwardRef, useEffect } from "react";
import { setActiveSection } from "../../store";

function TimelineSection({ preventIntersectionObserver }, ref) {
  const dispatch = useDispatch();
  const { resumeLink } = useSelector((store) => store.app);

  /**
   * This is a callback to begin the observation of the div when the component first renders.
   */
  useEffect(() => {
    /**
     * An interaction observer object that allows us to monitor any interaction between the section's
     * div, and the viewport (visible area). It will make the section active when it intersects the
     * viewport.
     */
    const observer = new IntersectionObserver(
      (data) => {
        if (!preventIntersectionObserver.current && data[0].isIntersecting)
          dispatch(setActiveSection("experience"));
      },
      {
        root: null,
        threshold: [0.7, 0.8],
        rootMargin: "0px 5px 0px 0px",
      }
    );
    observer.observe(ref.current);

    return () => {
      observer.disconnect();
    };
  }, [ref, dispatch, preventIntersectionObserver]);

  return (
    <div
      className="h-max w-full mt-5 mb-16 flex flex-col items-center"
      ref={ref}
    >
      <h1 className="text-white text-3xl w-full pl-3 mb-3">My Journey</h1>
      <p className="flex flex-row items-center pl-3 w-full mb-5 pl-hyperlink text-xs">
        <a
          href={resumeLink}
          target="_blank"
          className="active:underline"
          rel="noreferrer"
        >
          View Full Résumé
        </a>
      </p>
      <Timeline className="relative left-[-200px]" />
    </div>
  );
}

export default forwardRef(TimelineSection);
